import { render } from "./App.vue?vue&type=template&id=60cbce8d"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=60cbce8d&lang=css"

import exportComponent from "D:\\WorkGit\\GctMoreOnlineMarking\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__